import { APP_BASE_HREF } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { Router } from '@angular/router'

import { Store } from '@ngrx/store'
import { ColDef } from 'ag-grid-community'

import { TOKEN_STATE } from '@flowx/core-sdk'
import { PROCESS_INSTANCE_COLUMNS } from '@flowx/designer/modules/process/process.constants'
import {
  DefaultActionsColumn,
  FlxResourcesGridComponent,
} from '@flowx/designer/modules/projects/components/resources-grid/resources-grid.component'
import { ActionsCellComponent } from '@flowx/designer/shared/components/ag-grid/cell-components/actions-cell/actions-cell.component'
import { ApplicationDefinition } from '@flowx/designer/shared/entities/application.entity'
import { ProcessInstance } from '@flowx/designer/shared/entities/process-instance.types'
import { selectRouteParams } from '@flowx/designer/shared/store/selectors/router.selectors'

@Component({
  selector: 'flx-ui-flow-session-processes',
  templateUrl: './ui-flow-session-processes.component.html',
  styleUrls: ['./ui-flow-session-processes.component.scss'],
  imports: [FlxResourcesGridComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiFlowSessionProcessesComponent {
  #store = inject(Store)
  #router = inject(Router)
  #baseHref = inject(APP_BASE_HREF)

  processInstances = input<ProcessInstance[]>()

  items = computed(() =>
    this.processInstances()?.map((process) => ({
      ...process,
      node: process.tokens.find((token) => token.state === TOKEN_STATE.ACTIVE)?.currentNodeName,
    }))
  )

  tableColumnsDef: ColDef[] = [
    ...PROCESS_INSTANCE_COLUMNS,
    {
      ...DefaultActionsColumn,
      cellRenderer: ActionsCellComponent<ApplicationDefinition>,
      cellRendererParams: {
        actions: [
          {
            icon: 'ph-eye',
            tooltip: 'Navigate to process',
            clickAction: (process: ProcessInstance): void => {
              const { appId, workspaceId } = this.#store.selectSignal(selectRouteParams)()

              const url = this.#router.serializeUrl(
                this.#router.createUrlTree([
                  this.#baseHref,
                  'guard',
                  'workspace',
                  workspaceId,
                  'projects',
                  appId,
                  'runtime',
                  'active-instances',
                  process.uuid,
                ])
              )
              window.open(url, '_blank')
            },
          },
        ],
      },
    },
  ]
}
